import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import axios from 'axios';

export interface Tokens {
  access_token: string
  refresh_token: string
}

export interface State {
  user: Object,
  tokens: Tokens
  exhibitorId: string | null
  loadStatus: string
  userCompanyId: string | null
  showId: string | null
  eventId: string | null
}

const defaultState: State = {
  user: {},
  tokens: {
    access_token: localStorage.getItem('access-token') || '',
    refresh_token: localStorage.getItem('access-token') || ''
  },
  exhibitorId: null,
  loadStatus: '',
  userCompanyId: null,
  showId: null,
  eventId: null
}

const getters = {
  user:(state:State) => state.user,
  isAuthenticated: (state: State) => !!state.tokens.access_token,
  status: (state: State) => state.loadStatus,
  showId: (state: State) => state.showId
}

const mutations: MutationTree<State> = {
  setUser(state:State, payload:any){
    state.user = payload
  },
  loading(state: State) {
    state.loadStatus = 'loading'
  },

  tokenSetup(state: State, newTokens: Tokens) {
    state.loadStatus = 'success'
    state.tokens.access_token = newTokens.access_token
    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + newTokens.access_token
  },

  exhibitorSetup(state: State, exhibitorId: string) {
    state.exhibitorId = exhibitorId
  },
  userSetup(state: State, userObj: Object) {
    state.user = userObj
  },

  userCompanySetup(state: State, companyId: string) {
    state.userCompanyId = companyId
  },

  showSetup(state: State, showId: string) {
    state.showId = showId
  },

  eventSetup(state: State, eventId: string) {
    state.eventId = eventId
  },

  error(state: State) {
    state.loadStatus = 'error'
    state.tokens.access_token = ''
    state.tokens.refresh_token = ''
    state.exhibitorId = null
    state.showId = null
    state.eventId = null
  },

  clear(state: State) {
    state.loadStatus = ''
    state.tokens.access_token = ''
    state.tokens.refresh_token = ''
    state.exhibitorId = null
    state.showId = null
    state.eventId = null
    delete Vue.axios.defaults.headers.common['Authorization']
  }
}

const actions: ActionTree<State, RootState> = {
  login({commit}, {login, password}) {
    return new Promise((resolve, reject) => {
      localStorage.removeItem('access-token')
      localStorage.removeItem('refresh-token')
      commit('loading')
      Vue.axios({
        url: '/v4/login',
        method: 'POST',
        data: {
          login,
          password,
        },
      })
        .then((resp: any) => {
          if (resp.data.status === 'ok' && resp.data.access && (resp.data.role === "organizer" || resp.data.role === "support" )) {
            commit('tokenSetup', {access_token: resp.data.access})
            commit('userSetup',resp.data.user)
            localStorage.setItem('access-token', resp.data.access)
            localStorage.setItem('user', resp.data.user.name.first + ' ' +resp.data.user.name.middle + ' ' +resp.data.user.name.last)
            resolve({
              access_token: resp.data.access,
              refresh_token: resp.data.refresh
            })
          } else {
            reject(resp)
          }
        })
        .catch((err: any) => {
          commit('error')
          localStorage.removeItem('access-token')
          localStorage.removeItem('refresh-token')
          reject(err)
        })
    })
  },

  logout({commit}) {
    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/v3/auth/login',
        method: 'DELETE'
      })
        .then((resp: any) => {
          if (resp.data.status == 'ok') {
            commit('clear')
            localStorage.removeItem('access-token')
            localStorage.removeItem('refresh-token')
            localStorage.removeItem('exhibitor')
            localStorage.removeItem('userCompanyId')
            localStorage.removeItem('showId')
            localStorage.removeItem('eventId')
            resolve(false)
          }
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },

  restoreFromLS({commit}) {
    return new Promise((resolve, reject) => {
      const access_token = localStorage.getItem('access-token')
      const refresh_token = localStorage.getItem('refresh-token')
      const exhibitor = localStorage.getItem('exhibitor')
      const userCompanyId = localStorage.getItem('userCompanyId')
      const showId = localStorage.getItem('showId')
      const eventId = localStorage.getItem('eventId')

      if (access_token && refresh_token && exhibitor && userCompanyId && showId && eventId) {
        commit('tokenSetup', {access_token, refresh_token})
        commit('exhibitorSetup', exhibitor)
        commit('userCompanySetup', userCompanyId)
        commit('showSetup', showId)
        commit('eventSetup', eventId)
        resolve({access_token, refresh_token, exhibitor, userCompanyId, showId, eventId})
      } else {
        commit('clear')
        localStorage.removeItem('access-token')
        localStorage.removeItem('refresh-token')
        localStorage.removeItem('exhibitor')
        localStorage.removeItem('userCompanyId')
        localStorage.removeItem('showId')
        localStorage.removeItem('eventId')
        reject()
      }
    })
  },

  refresh({commit}, refresh_token: string) {

    return new Promise((resolve, reject) => {
      Vue.axios({
        url: '/auth/refresh',
        method: 'POST',
        data: {
          refresh: refresh_token,
        },
      })
        .then((resp: any) => {
          if (resp.data.status == 'ok' && resp.data.access && resp.data.refresh) {
            localStorage.setItem('access-token', resp.data.access);
            localStorage.setItem('refresh-token', resp.data.refresh);
            commit('tokenSetup', {access_token: resp.data.access, refresh_token: resp.data.refresh});
            resolve(resp);
          }
        })
        .catch((err: any) => {
          reject(err);
        });
    })

  },
  async refreshUser({commit}) {
    try {
      const {data} = await axios.get('/v4/user')
      if(data.status === 'err'){
        throw (data.error)
      } else {
        commit('setUser',data)
      }

        }catch (e) {
      console.log(e)
    }


  }




}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
